(function(){
  function wire(cue){
    if (cue.dataset.cueWired) return;
    cue.dataset.cueWired = '1';
    var slider = cue.closest('.o16-cat-slider'); if(!slider) return;
    var track = slider.querySelector('.collections-grid, .o16-category-pairs__grid'); if(!track) return;
    cue.addEventListener('click', function(){
      var max = track.scrollWidth - track.clientWidth;
      var step = Math.max(track.clientWidth * 0.8, 200);
      if (track.scrollLeft >= max - 5) { track.scrollTo({left:0, behavior:'smooth'}); }
      else { track.scrollBy({left:step, behavior:'smooth'}); }
    });
  }
  function init(){ document.querySelectorAll('.o16-cat-slider__cue').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
